import { render, staticRenderFns } from "./EvaluationsDetails.vue?vue&type=template&id=e4b8d034"
import script from "./EvaluationsDetails.vue?vue&type=script&lang=js"
export * from "./EvaluationsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports